import styled from "styled-components";
import ContactUsElement from "./Components/ContactUsElement";
import Footer from "./Components/Footer";
import Header from "./Components/Header";
import IntroElement from "./Components/IntroElement";
import OurProjectsElement from "./Components/OurProjectsElement";

import { RouterProvider, createBrowserRouter } from "react-router-dom";
import ThermometerAppPrivacyPolicy from "./screens/ThermometerAppPrivacyPolicy";
import BadtempenAppPrivacyPolicy from "./screens/BadtempenAppPrivacyPolicy";
import SunSafelyAppPrivacyPolicy from "./screens/SunSafelyAppPrivacyPolicy";

const Wrapper = styled.div`
  width: 100vw;
  height: 100vh;
`;

const Home = (): JSX.Element => {
  return (
    <>
      <Header />
      <IntroElement />
      <OurProjectsElement />
      <ContactUsElement />
      <Footer />
    </>
  );
};

const router = createBrowserRouter([
  {
    path: "*",
    element: <Home />,
  },
  {
    path: "/thermometer-app-privacy-policy",
    element: <ThermometerAppPrivacyPolicy />,
  },
  {
    path: "/badtempen-privacy-policy",
    element: <BadtempenAppPrivacyPolicy />,
  },
  {
    path: "/sun-safely-privacy-policy",
    element: <SunSafelyAppPrivacyPolicy />,
  },
]);

function App() {
  return (
    <Wrapper>
      <RouterProvider router={router} />
    </Wrapper>
  );
}

export default App;
